import { RecordTableLoading } from './record-table-loading';
import { useRecordList } from '../hooks/useRecordList';
import styles from './record-list.module.css';
import { Fragment } from 'react/jsx-runtime';
import { RecordTable } from './record-table';
import classNames from 'classnames';

export function RecordList() {
  const { data = [], isLoading } = useRecordList();

  return (
    <div className={classNames(styles.list, styles['gap-6'])}>
      {isLoading ? (
        <RecordTableLoading />
      ) : (
        data.map(rct => (
          <Fragment key={rct.id}>
            {rct.records.map((discipline, index) => (
              <RecordTable discipline={discipline} key={`discipline-${index}`} />
            ))}
          </Fragment>
        ))
      )}
    </div>
  );
}
